// Constants
export { PROJECT_NAME } from './PROJECT_NAME';
export { PROJECT_DESCRIPTION } from './PROJECT_DESCRIPTION';
export { PROJECT_DOMAIN } from './PROJECT_DOMAIN';
export { PROJECT_YEAR } from './PROJECT_YEAR';
export { PROJECT_COPYRIGHT } from './PROJECT_COPYRIGHT'; 